import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AUMICO_AI_AGENTS_CONFIG, AumicoAiAgentsConfig } from '../aumico-ai-agents.config';
import type { OrgAiSettings, SetAiFeaturesRequest } from '../interfaces/ai-org-settings.interface';

@Injectable()
export class AiOrgSettingsService {
    private readonly baseUrl: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(AUMICO_AI_AGENTS_CONFIG) config: AumicoAiAgentsConfig,
    ) {
        this.baseUrl = config.apiGateway.endsWith('/') ? config.apiGateway : `${config.apiGateway}/`;
    }

    getOrgSettings$(organizationId: string): Observable<OrgAiSettings> {
        return this.http.get<OrgAiSettings>(`${this.baseUrl}ai/org-settings/${organizationId}`);
    }

    /** Master "AI features" toggle. Enabling requires acceptedVersion === masterAgb.version. */
    setAiFeatures$(organizationId: string, body: SetAiFeaturesRequest): Observable<void> {
        return this.http.patch<void>(`${this.baseUrl}ai/org-settings/${organizationId}/ai-features`, body);
    }
}
